/** True when the viewport forces the collapsed sidebar (≤1279px) regardless of stored preference — mirrors the `max-width: 1279px` media queries in sidebar styles. */
export function isViewportCollapsed(): boolean {
  return globalThis.matchMedia('(max-width: 1279px)').matches;
}
